module.exports = __webpack_public_path__ + "media/application/images/2023/06_still-1920x1080-70c7cc692ff32c80b24938f300fb13c6.png";